export enum Alignment {
    BOTTOM = 'bottom',
    TOP = 'top',
    RIGHT = 'right',
    LEFT = 'left',
    CENTER = 'center',
    MIDDLE = 'middle'
};
